import React from 'react';
import SingleFeatureTwo from '../../components/Feature/SingleFeatureTwo';

import featureImg1 from '../../assets/img/feature/fea-1.png';
import featureImg2 from '../../assets/img/feature/fea-2.png';
import featureImg3 from '../../assets/img/feature/fea-3.png';
import featureImg4 from '../../assets/img/feature/fea-4.png';

const Feature = () => {
  return (
    <div className="feature__area feature__mlr pt-100 pb-40">
      <div className="container-fluid">
        <div className="row align-items-end mb-150">
          <div className="col-xl-6 col-lg-6">
            <div className="feature__section-box">
              <h4
                className="section-subtitle char-anim wow animate__fadeInUp align-items-center"
                data-wow-duration="1.1s"
                data-wow-delay=".3s"
              >
               <b> What We Offer </b>
              </h4>
              <h3 className="section-title char-anim">
                Experts in Every Aspect of <br />
                the Technology Lifecycle
              </h3>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="feature__top-text">
              <p  className="mb-0 char-anim-2">
                We blend code and creativity to craft solutions that don’t just function—they feel right. From sleek interfaces to smart tech integrations, we shape digital experiences that connect and convert.
              </p>
              <br />
              <p className="mb-0 char-anim-2">
                Our expertise spans full-stack development, cloud-native architecture, and AI-driven systems. We deliver robust, scalable, and secure technology solutions aligned with enterprise-grade standards and performance.{' '}
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-3 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleFeatureTwo
              Image={featureImg1}
              Title="Custom Software Development"
              //btnURL="service-1"
              Description="Build What Your Business Needs - We engineer robust web, mobile, and enterprise applications tailored to your unique workflows, built to scale with your growth."
            />
          </div>
          <div
            className="col-xl-3 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleFeatureTwo
              Image={featureImg2}
              Title="Cloud & DevOps Solutions"
              //btnURL="service-1"
              Description="Deliver Faster, Operate Smarter - Optimize infrastructure, automate deployments, and enable continuous delivery with our end-to-end cloud and DevOps services."
            />
          </div>
          <div
            className="col-xl-3 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleFeatureTwo
              Image={featureImg3}
              Title="AI & Machine Learning"
              //btnURL="service-1"
              Description="Turn Data Into Intelligence - We integrate custom AI and ML models to automate processes, deliver predictive insights, and give your business a competitive edge."
            />
          </div>
          <div
            className="col-xl-3 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <SingleFeatureTwo
              Image={featureImg4}
              Title="IT Consulting & Strategy"
              //btnURL="service-1"
              Description="Your Technology Growth Partner - We provide technical direction and strategic planning to align your IT infrastructure with long-term business goals."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
